<template>
  <div ref="radioButtonRef" class="radio-button" :class="computedClasses">
    <input
      :id="id"
      class="radio-button__input"
      :name="name"
      :value="value"
      :checked="checked"
      @change="$emit('change', $event)"
      type="radio"
    />
    <label class="radio-button__label text-$KQ-Grey1" :for="id">
      {{ label }}
    </label>
  </div>
  <div v-if="hasError" class="radio-button__error">
    <p>{{ error }}</p>
  </div>
</template>

<script setup>
import { onBeforeMount, ref, watch, computed } from 'vue';

const hasError = ref(false);
const props = defineProps({
  label: {
    type: String,
    default: '',
    required: true,
  },
  name: {
    type: String,
    default: '',
    required: true,
  },
  value: {
    type: String,
    default: '',
    required: true,
  },
  id: {
    type: String,
    default: '',
    required: true,
  },
  error: {
    type: String,
    default: '',
  },
  checked: {
    type: Boolean,
    default: false,
  },
});

onBeforeMount(() => {
  hasError.value = props?.error?.length > 0;
});

watch(
  () => props.error,
  () => {
    hasError.value = props?.error?.length > 0;
  },
);

const computedClasses = computed(() => {
  return {
    hasError: hasError.value,
    [`${props.additionalClasses}`]: props.additionalClasses,
  };
});
</script>
